import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import Segment from '../../interfaces/segment';

interface SegmentState {
    segments: Segment[],
}

const initialState: SegmentState = {
    segments: []
}

export const segmentSlice = createSlice({
    name: 'segments',
    initialState,
    reducers: {
        loadSegments: (state, action: PayloadAction<Segment[]>) => {
            state.segments = action.payload
        }
    }
});

export const {loadSegments} = segmentSlice.actions;

export default segmentSlice.reducer;